import type {
  AvgCheckResponse,
  RevenueDistributionResponse,
  TotalRevenueResponse,
} from "@/types/analytics-revenue";
import { formatAnalyticsCurrency } from "../shared/analyticsFormatting";

export const DEFAULT_REVENUE_CURRENCY = "EUR";

export function collectRevenueCurrencies(
  total?: TotalRevenueResponse,
  avgCheck?: AvgCheckResponse,
  distribution?: RevenueDistributionResponse,
): string[] {
  const codes = new Set<string>();

  for (const row of total?.totals.byCurrency ?? []) {
    if (row.currency) {
      codes.add(row.currency);
    }
  }

  for (const row of avgCheck?.totals.byCurrency ?? []) {
    if (row.currency) {
      codes.add(row.currency);
    }
  }

  for (const row of distribution?.totals.grand ?? []) {
    if (row.currency) {
      codes.add(row.currency);
    }
  }

  return [...codes].sort((a, b) => a.localeCompare(b));
}

export function resolveRevenueCurrency(
  currencies: string[],
  preferred?: string,
): string {
  if (preferred && currencies.includes(preferred)) {
    return preferred;
  }

  return currencies[0] ?? DEFAULT_REVENUE_CURRENCY;
}

export function formatRevenueCurrency(
  value: number,
  currency: string,
  options?: { maximumFractionDigits?: number },
): string {
  const maximumFractionDigits = options?.maximumFractionDigits ?? 1;

  try {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits,
    });
  } catch {
    return formatAnalyticsCurrency(value, {
      maximumFractionDigits,
      symbol: currency,
      symbolPosition: "suffix",
    });
  }
}

export function formatRevenueCenterLabel(
  value: number,
  currency: string,
): string {
  return formatRevenueCurrency(Math.round(value), currency, {
    maximumFractionDigits: 0,
  });
}
